





































































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums/Data
import { ImageUploadTypes } from "@/data/constants";
import { BASE_URL } from "@/store/modules/api";

@Component
export default class ImageGalleryUploadImage extends Vue {
  @Prop({ required: true })
  public value;

  @Prop({ default: false })
  public isDisabled!: boolean;

  public hoverMsg = "";

  public get images() {
    return [this.value];
  }

  public set images(images) {
    const newImages = this.$_.filter(
      images,
      image => !this.$_.has(image, "exists")
    );
    if (!newImages.length) {
      return;
    }

    const newTypedImages = this.$_.filter(images, image =>
      ImageUploadTypes.includes(this.$_.get(image, "type"))
    );
    if (newTypedImages.length !== newImages.length) {
      this.$store.dispatch("toast/error", {
        message: this.$t("_sentence.wrong_file_type")
      });
    }

    if (!newTypedImages.length) {
      return;
    }

    this.$emit("newImages", newTypedImages, this.$_.get(this.image, "id", ""));
  }

  public get image() {
    return this.$_.get(this.images, "[0]");
  }

  public showPreview(event, image = {}) {
    this.$emit("showPreview", image);

    if (this.$_.isEmpty(image)) {
      event.target.classList.remove("image-is-hovered");
    } else {
      event.target.classList.add("image-is-hovered");
    }
  }

  public get imageSrc() {
    if (
      this.$_.get(this.image, "exists", false) &&
      this.$_.get(this.image, "imageObj.type")
    ) {
      return `url(${URL.createObjectURL(this.$_.get(this.image, "imageObj"))})`;
    }

    if (
      this.$_.get(this.image, "exists", false) &&
      this.$_.get(this.image, "hash", false)
    ) {
      return `url(${BASE_URL}api/images/${this.image.hash}/download?size=400x400)`;
    }

    return "";
  }

  public get imageExists() {
    return this.image.exists;
  }

  public deleteImage() {
    this.$emit("deleteImage", this.image.id);
  }

  public setDefault() {
    this.$emit("input", this.$_.merge(this.image, { isUploading: true }));
    this.$emit("setDefault", this.image.id);
  }
}
